import React, { Component } from "react";
import moment from "moment-timezone";
import { translate } from "react-i18next";
import { Field, reduxForm } from "redux-form";
import { BaseUserProfile } from "fitbeat.models";
import { Platform, StyleSheet, View, Image, Text, TouchableOpacity } from "react-native";
import { Dropdown } from "../ui/components";
import { normalizeDateDDMMYYYY, isRequired, formatMobileNumber } from "../utils";
import {
  isNameValid,
  minHeight,
  maxHeight,
  isNumberRequired,
  isPhoneNumberValid,
  isValidDate,
} from "../utils/validator";
import { focusOnInput } from "../utils/FocusOnInput";
import { GymLocation } from "../Bookings/components/GymLocation";
import PhoneInput from "react-native-phone-input";
import theme from "../theme";
import { styles } from "./SignupFormsStyles";
const isMobileWeb = Platform.OS === "web" && window.innerWidth <= 550;

class BasicDetailFields extends Component {
  constructor(props) {
    super(props);
    const { t } = props;
    const genders = [
      {
        display: t("formFields:male"),
        value: "male"
      },
      {
        display: t("formFields:female"),
        value: "female"
      },
      {
        display: t("formFields:other"),
        value: "other"
      }
    ];

    this.state = {
      message: null,
      isUnderage: false,
      genders,
    };
  }

  componentDidUpdate = async (prevProps) => {
    if (JSON.stringify(prevProps.initialValues) !== JSON.stringify(this.props.initialValues)) {
      await this.initializeForm();
    }
  }

  componentDidMount = async () => {
    if (this.phone) {
      const pickerData = this.getCountryDropDown();
      this.setState({
        pickerData,
      });

      if (pickerData) {
        let pickerDataWithImage = pickerData.map(country => {
          country.thumbnail = this.getCountryPickerElement(
            country.image,
            country.dialCode
          );
          return country;
        });

        this.setState({
          pickerDataWithImage
        });
      }
    }
    await this.initializeForm();
  };

  initializeForm = async () => {
    const { initialValues, initialize } = this.props;
    await this.setState({ defaultCountry: this.defaultCountry() });
    initialValues.mobileNumber = this.separateMobileNumber(initialValues.mobileNumber);
    initialize(initialValues);
  }

  separateMobileNumber = mobileNumber => {
    if (mobileNumber) {
      const phoneNumber = mobileNumber.slice(-9);
      return phoneNumber;
    }
    return "";
  };

  getDialCode = () => {
    const mobileNumber = this.props.initialValues.mobileNumber;
    if (mobileNumber) {
      const lengthOfNumber = mobileNumber.length;
      const dialCodeLength = lengthOfNumber - 9;
      const dialCode = mobileNumber.slice(0, dialCodeLength);
      return dialCode;
    }
    return this.countryCode ? this.countryCode.value : this.phone.state.formattedNumber
  }

  defaultCountry = () => {
    if (!this.phone) {
      return;
    }
    const pickerData = this.getCountryDropDown();
    const mobileNumber = this.props.initialValues.mobileNumber;
    if (mobileNumber) {
      const lengthOfNumber = mobileNumber.length;
      const dialCodeLength = lengthOfNumber - 9;
      const dialCode = mobileNumber.slice(0, dialCodeLength);
      const indexOfDialCode = pickerData.map(e => e.dialCode).indexOf(dialCode);
      if(Platform.OS === 'web') {
        return pickerData[indexOfDialCode].dialCode;
      } else {
        this.phone.selectCountry(pickerData[indexOfDialCode].iso2);
        return pickerData[indexOfDialCode].dialCode;
      }
    } else {
      if(Platform.OS === 'web') {
      const indexOfAus = pickerData.map(e => e.iso2).indexOf("au");
      return pickerData[indexOfAus].dialCode;
      } else {
        const indexOfAus = pickerData.map(e => e.iso2).indexOf("au");
        return pickerData[indexOfAus].dialCode;
      }
    }
  };

  getCountryDropDown = () => {
    return this.phone.getPickerData();
  };

  onDateSelect = dateOfBirth => {
    this.calculateAge(dateOfBirth);
  };

  onDateSelectWeb = (event, dateOfBirth) => {
    this.calculateAge(dateOfBirth);
  };

  setBranch = branch => {
    this.props.change("branch", branch);
  };

  calculateAge = dateOfBirthString => {
    const { t } = this.props;
    const dateOfBirth = moment(dateOfBirthString, "DD-MM-YYYY").toDate();
    const age = BaseUserProfile.getAge(dateOfBirth);
    let message;
    let isUnderage = false;
    if (age < 16) {
      message = t("underage");
      isUnderage = true;
    }
    this.setState({ message, isUnderage });
  };

  getDropdownRowWidth = () => {
    const isMobile = window.innerWidth <= 550;
    if (Platform.OS == "web") {
      if (isMobile) {
        return "70%";
      }
      return "25%";
    }
    return "90%";
  };

  getCountryPickerElement = (thumbnailLink, dialCode) => {
    let thumbnailElement = <View style={styling.thumbnailElementView} />;
    if (thumbnailLink) {
      thumbnailElement = (
        <View style={styling.thumbnailElement}>
          <Image
            resizeMode={"cover"}
            style={styling.thumbnailElementImageWeb}
            source={{ uri: thumbnailLink }}
          />
          <Text style={styling.thumbnailText}>{dialCode}</Text>
        </View>
      );
    }
    return thumbnailElement;
  };

  formatAndSubmitValues = (customSubmit) => () => {
    const cc = this.getDialCode() ? this.getDialCode() : this.phone.state.formattedNumber;
    return this.props.handleSubmit(values => {
      const copiedValues = { ...values };
      copiedValues.mobileNumber = formatMobileNumber(cc, copiedValues.mobileNumber);
      customSubmit(copiedValues);
    })();
  }

  showPicker = () => {
    this.phone.picker.show();
  }

  render() {
    const {
      t,
      handleSubmit,
      textInputComponent,
      datePickerComponent,
      renderGenderAndHeight = true
    } = this.props;
    const {
      genders,
      message,
      isUnderage,
      defaultCountry,
      pickerDataWithImage,
    } = this.state;
    const renderGymLocation = false;

    return (
      <>
        <Field
          trim
          forwardRef
          showLabel={true}
          name="firstname"
          placeholder={t("formFields:firstname")}
          component={textInputComponent}
          returnKeyType="next"
          autoCapitalize="words"
          validate={isNameValid}
          onSubmitEditing={() => focusOnInput(this.lastnameInput)}
          ref={ref => {
            this.firstnameInput = ref;
          }}
        />

        <Field
          trim
          forwardRef
          showLabel={true}
          name="lastname"
          placeholder={t("formFields:lastname")}
          component={textInputComponent}
          returnKeyType="next"
          autoCapitalize="words"
          validate={isNameValid}
          onSubmitEditing={() => focusOnInput(this.genderInput)}
          ref={ref => {
            this.lastnameInput = ref;
          }}
        />

        {Platform.OS == "web" ? (
          <View style={styling.phoneNumberContainer}>
            <View style={styling.phoneInputContainerWeb}>
              <PhoneInput
                initialCountry="au"
                ref={ref => {
                  this.phone = ref;
                }}
                style={styling.phoneInputWeb}
              />
              <Field
                forwardRef
                showThumbnailInLabel
                name="countryCode"
                showLabel={false}
                valueKey="dialCode"
                displayKey="label"
                isRequired={false}
                defaultValue={defaultCountry}
                placeholder="thumbnail"
                options={pickerDataWithImage ? pickerDataWithImage : []}
                component={Dropdown}
                isSearchable={true}
                rowWidth={this.getDropdownRowWidth()}
                height="100%"
                ref={ref => {
                  this.countryCode = ref;
                }}
              />
            </View>
            <View style={styling.mobileNumberContainerWeb}>
              <Field
                forwardRef
                name="mobileNumber"
                component={textInputComponent}
                autoCapitalize="none"
                placeholder={t("formFields:mobileNumber")}
                keyboardType="numeric"
                returnKeyType="next"
                validate={[isRequired, isPhoneNumberValid]}
                ref={ref => {
                  this.mobileNumberInput = ref;
                }}
                textInputStyle={{ width: '100%' }}
                showLabel={false}
              />
            </View>
          </View>
        ) : (
          <View style={styling.phoneNumberContainer}>
            <TouchableOpacity onPress={() => {this.showPicker()}}>
            <View style={styling.phoneInputContainer} ref={node => { this.node = node; }}>
              <PhoneInput
                ref={ref => {
                  this.phone = ref;
                }}
                initialCountry='au'
                selectCountry={defaultCountry}
                pickerButtonColor={theme.PRIMARY}
                buttonTextStyle={styling.pickerButton}
                textProps={{ editable: false, disabled: true }}
                pickerItemStyle={styling.pickerItemStyle}
                style={styling.phoneInput}
                textStyle={styling.phoneInputText}
              />
            </View>
            </TouchableOpacity>
            <View style={styling.mobileNumberContainer}>
              <Field
                forwardRef
                name="mobileNumber"
                component={textInputComponent}
                autoCapitalize="none"
                placeholder={t("formFields:mobileNumber")}
                keyboardType="numeric"
                validate={[isRequired, isPhoneNumberValid]}
                ref={ref => {
                  this.mobileNumberInput = ref;
                }}
                showLabel={false}
                onSubmitEditing={handleSubmit}
              />
            </View>
          </View>
        )}

        <Field
          forwardRef
          confirmText="Confirm date of birth"
          disableMinAgeRestriction
          name="dateOfBirth"
          showLabel={true}
          onChange={
            Platform.OS === "web" ? this.onDateSelectWeb : this.onDateSelect
          }
          component={datePickerComponent}
          normalize={normalizeDateDDMMYYYY}
          validate={[isValidDate, isRequired]}
          placeholder={
            Platform.OS === "web"
              ? t("formFields:dateOfBirthWeb")
              : t("formFields:dateOfBirthNoRestriction")
          }
          ref={ref => {
            this.dateOfBirthInput = ref;
          }}
        />
        {renderGenderAndHeight && (
          <Field
            forwardRef
            name="gender"
            showLabel={true}
            placeholder={t("formFields:gender")}
            valueKey="value"
            displayKey="display"
            defaultIndex={-1}
            options={genders}
            component={Dropdown}
            isSearchable={false}
            rowWidth={this.getDropdownRowWidth()}
            validate={isNameValid}
            onSubmitEditing={() => focusOnInput(this.dateOfBirthInput)}
            ref={ref => {
              this.genderInput = ref;
            }}
          />
        )}

        {renderGenderAndHeight && (
          <Field
            forwardRef
            name="height"
            component={textInputComponent}
            autoCapitalize="none"
            placeholder={t("formFields:height")}
            keyboardType="numeric"
            returnKeyType="next"
            validate={[isNumberRequired, minHeight, maxHeight]}
            ref={ref => {
              this.heightInput = ref;
            }}
          />
        )}

        {renderGymLocation && (
          <GymLocation showLabel onSelect={this.setBranch} />
        )}

        <>
          {this.props.render({
            message,
            handleSubmit: this.formatAndSubmitValues,
            isUnderage
          })}
        </>
      </>
    );
  }
}

const styling = StyleSheet.create({
  phoneInput: {
    backgroundColor: theme.GREY_LIGHT,
    borderRadius: 3,
    paddingHorizontal: 10,
    paddingVertical: 10,
    marginTop: 5,
    marginBottom: 5,
    width: "100%"
  },
  phoneInputWeb: {
    display: "none"
  },
  phoneInputContainer: {
    width: 120,
    marginRight: 5
  },
  phoneInputContainerWeb: {
    width: "35%",
    marginRight: 5,
    marginTop: 6
  },
  mobileNumberContainer: {
    flex: 1
  },
  mobileNumberContainerWeb: {
    flex: 1,
  },
  phoneNumberContainer: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  mobileNumberInput: {
    width: "100%"
  },
  pickerItemStyle: {
    fontSize: 24, 
  },
  thumbnailElement: {
    flexDirection: "row",
    alignItems: "flex-start"
  },
  thumbnailElementView: {
    backgroundColor: theme.WHITE,
    width: 25,
    height: 15,
    flexDirection: "row",
    alignItems: "flex-start"
  },
  thumbnailElementImage: {
    width: 25,
    height: 15,
    marginTop: 13
  },
  thumbnailElementImageWeb: {
    width: 25,
    height: 15,
    marginTop: 5
  },
  phoneInputText: {
    color: "black",
  },
  thumbnailText: {
    marginLeft: 5,
    marginTop: 2
  },
  pickerButton: {
    fontSize: 16
  }
});

BasicDetailFields = translate(["auth", "formFields"], { wait: true })(
  BasicDetailFields
);
BasicDetailFields = reduxForm({
  form: "AgeRestrictionForm",
  enableReinitialize: true
})(BasicDetailFields);
export default BasicDetailFields;
